import script from "./RealNameModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RealNameModal.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./RealNameModal.vue?vue&type=style&index=0&id=560cbc20&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../apps/evankao/game-yiyouwang/yywfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__